import React, { useState, useContext, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import InfoBox from 'components/formElements/InfoBox';

import { Link } from "react-router-dom";

import { FormContext } from 'context/FormContext';

import RangeSlider from 'components/formElements/RangeSlider'
import MapRoofObstacleSelection from 'components/formElements/MapRoofObstacleSelection';
import Label from 'components/formElements/Label';

import IconLineMockup from 'assets/images/icon_roof_linemockup.svg';
import IconPlus from 'assets/images/icon_circle_plus.svg';
import ImageButton from 'components/formElements/ImageButton';
import ActionIcon from 'components/formElements/ActionIcon';
import IconTrash from 'assets/images/icon_trash.svg';
import BackgroundMaps from 'assets/images/background_maps.png';

const RoofObstacles = () => {
    const { formValues, setFormValues } = useContext(FormContext);
    const [selectedZone, setSelectedZone] = useState(0);
    const [displayInfobox, setDisplayInfobox] = useState(false);
    const [showRoofSettings, setShowRoofSettings] = useState(false);
    const [formErrors, setFormErrors] = useState([]);

    const addZone = () => {
        const newValues = { ...formValues };
        newValues.Roof.Obstacles = [...newValues.Roof.Obstacles, {
            SquareMeter: 0,
            Points: []
        }];
        setFormValues(newValues);
        setSelectedZone(newValues.Roof.Obstacles.length - 1);
        setShowRoofSettings(false);
        setFormErrors([]);
    }

    const removeZone = (zindex) => {
        const newValues = { ...formValues };
        newValues.Roof.Obstacles.splice(zindex, 1)
        setFormValues(newValues);
    }

    const DynamicToast = (props) => {
        const [show, setShow] = useState(true);

        return (
            <Toast onClose={() => setShow(false)} show={show} delay={3000} bg="danger" autohide>
                <Toast.Body>{props.children}</Toast.Body>
            </Toast>
        );
    }

    const getTotalSquareMeterUsable = () => {
        return formValues.Roof.Zones.reduce((sum, zone) => sum + (zone.SquareMeterUsable || 0), 0);
    };

    const handleFormCheck = (e) => {
        let checkHasFailed = false;
        let errorMessages = [];

        // if(formValues.Roof.Obstacles.length === 0){
        //     errorMessages.push('Wählen Sie mindestens ein Hinderniss aus');
        //     checkHasFailed = true;
        // } else {
        //     formValues.Roof.Obstacles.map((obstacle, index) => {
        //         if(!obstacle.hasOwnProperty('Points') || obstacle.Points.length === 0 || obstacle.Points.length < 3){
        //             errorMessages.push(`Hinderniss ${index+1} ist unvollständig.`);
        //             checkHasFailed = true;
        //         }
        //     });

        //     if (getTotalSquareMeterUsable() == 0) {
        //         errorMessages.push(`Die benutzbare Fläche muss größer als 0 sein.`);
        //         checkHasFailed = true;
        //     }
        // }

        if(formValues.Roof.Obstacles.length > 0) {
            formValues.Roof.Obstacles.map((obstacle, index) => {
                if(!obstacle.hasOwnProperty('Points') || obstacle.Points.length === 0 || obstacle.Points.length < 3){
                    errorMessages.push(`Hinderniss ${index+1} ist unvollständig.`);
                    checkHasFailed = true;
                }
            });
            if (getTotalSquareMeterUsable() == 0) {
                errorMessages.push(`Die benutzbare Fläche muss größer als 0 sein.`);
                checkHasFailed = true;
            }
        }

        if(checkHasFailed === true){
            e.preventDefault();
            setFormErrors(errorMessages);
        }
    }

    const mapBackgroundStyle = {
        background: `url(${BackgroundMaps}) no-repeat`,
        backgroundSize: 'cover'
    };

    const handleObstacleClick = (zindex) => {
        setSelectedZone(zindex);
        setShowRoofSettings(false);
        setFormErrors([]);
    }

    const FloatingButton = (props) => {
        return (
            <div className={`FloatingButton cursor-pointer ${props.visible ? 'visible' : ''}`} onClick={props.onClick}>
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 0C6.03 0 0 6.03 0 13.5C0 20.97 6.03 27 13.5 27C20.97 27 27 20.97 27 13.5C27 6.03 20.97 0 13.5 0ZM15 19.77C15 20.5801 14.3101 21.2401 13.5 21.2401C12.6899 21.2401 12 20.5801 12 19.77V12.09C12 11.2799 12.6899 10.6199 13.5 10.6199C14.3101 10.6199 15 11.2799 15 12.09V19.77ZM13.5299 8.7C12.7199 8.7 12.0599 8.04 12.0599 7.22995C12.0599 6.41989 12.7199 5.75989 13.5299 5.75989C14.34 5.75989 15 6.41989 15 7.22995C15 8.04 14.34 8.7 13.5299 8.7Z" fill="#5CC244"/></svg>
            </div>
        )
    }

    return (
        <Row className="full-height">
            <Col className="">
                <div className="ContainerPaddingSmall">
                    <div className={`roofSettings ${showRoofSettings ? 'active' : ''}`}>
                        <Stack gap={3}>
                            <h1 className="mb-0">Hindernisse</h1>
                            <div>Bitte zeichnen Sie Hindernisse wie beispielsweise Gauben oder Satellitenschüsseln auf Ihrem Dach in der rechts abgebildeten Sattelitenaufnahme ein.</div>

                            <Label text="Hindernisse" />
                            <Stack gap={3} direction="horizontal" className="flex-wrap">
                                {formValues.Roof.Obstacles.map((zone, zindex) => (
                                    <div key={zindex}>
                                        <ImageButton label={formValues.Roof.Obstacles[zindex].SquareMeter.toFixed(2) + " m²"} className={zindex === selectedZone ? 'active' : ''} image={IconLineMockup} onClick={() => handleObstacleClick(zindex)}>
                                            <ActionIcon image={IconTrash} data-index={zindex} onClick={e => {e.preventDefault(); e.stopPropagation(); removeZone(zindex)}} />
                                        </ImageButton>
                                    </div>
                                ))}
                            </Stack>
                            <hr />
                            <ImageButton label="Hindernis hinzufügen" image={IconPlus} onClick={addZone} />
                        </Stack>
                        <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                            <Link className={`order-1 order-md-0 btn-previous`} to="/RoofArea"><Button variant="outline-light">Zurück</Button></Link>
                            <Link className={`order-0 order-md-1 btn-next ${showRoofSettings ? '' : 'hide-mobile'}`} to="/EnergyConsumption" onClick={handleFormCheck}><Button variant="success">Weiter zum nächsten Schritt</Button></Link>
                        </Stack>
                        {formErrors.length > 0 &&
                            <ToastContainer className="position-absolute" position="middle-center">
                                <DynamicToast>
                                {formErrors.map((error, index) => (
                                    <div key={index}>{error}</div>
                                ))}
                                </DynamicToast>
                            </ToastContainer>
                        }
                    </div>
                </div>
            </Col>
            <Col className="backgroundMaps mapContainerWrapper" onClick={e => setFormErrors([])} style={mapBackgroundStyle}>
                <MapRoofObstacleSelection selectedZone={ selectedZone } />
                <InfoBox absolute hidden={displayInfobox}>
                    <div className="d-flex">
                        <div>Optional: Markieren Sie mindestens 3 Punkte auf der Abbildung, um das Hindernis hinzuzufügen.</div>                        
                    </div>
                </InfoBox>
                {/* <InfoBox absolute hidden={displayInfobox}>
                    <div className="d-flex">
                        <div>Bitte markieren Sie mindestens 4 Punkte auf der Abbildung, um ein Hindernis hinzuzufügen.</div>
                    </div>
                </InfoBox> */}
                <FloatingButton visible={displayInfobox} onClick={e => setDisplayInfobox(false)} />
            </Col>

            { !showRoofSettings && 
            <div className="mobileControls d-flex flex-row">
                <div className="align-items-center justify-content-center me-3">                    
                    <ImageButton 
                        disabled={!(formValues.Roof.Obstacles.length == 0 || (formValues.Roof.Obstacles.length > 0 && formValues.Roof.Obstacles[ selectedZone ] && formValues.Roof.Obstacles[ selectedZone ].hasOwnProperty('Points') && (formValues.Roof.Obstacles[ selectedZone ].Points.length > 2 || formValues.Roof.Obstacles[ selectedZone ].Points.length === 0)))}
                        label="Hindernis hinzufügen" image={IconPlus} onClick={addZone} />                                    
                </div>
                <Row className="mobileControlsRightPanel align-items-center justify-content-center">                    
                    <Col xs={8} className="text-center">
                            <div>{"Hindernis " + (selectedZone + 1) + " markieren"}</div>
                        </Col>
                    <Col xs={4} className="d-flex justify-content-end" onClick={e => {
                        if(formValues.Roof.Obstacles.length == 0 || (formValues.Roof.Obstacles.length > 0 && formValues.Roof.Obstacles[ selectedZone ] && formValues.Roof.Obstacles[ selectedZone ].hasOwnProperty('Points') && (formValues.Roof.Obstacles[ selectedZone ].Points.length > 2 || formValues.Roof.Obstacles[ selectedZone ].Points.length === 0))){
                            setShowRoofSettings(true);
                            setFormErrors([]);
                        }
                        }}><svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="32.5" cy="32.5" r="32.5" fill={ formValues.Roof.Obstacles.length == 0 || (formValues.Roof.Obstacles.length > 0 && formValues.Roof.Obstacles[ selectedZone ] && formValues.Roof.Obstacles[ selectedZone ].hasOwnProperty('Points') && (formValues.Roof.Obstacles[ selectedZone ].Points.length > 2 || formValues.Roof.Obstacles[ selectedZone ].Points.length === 0)) ? "rgb(92, 194, 68)" : "#333D46" }/>
                        <path d="M18 34.363L20.9408 37.2L26.2164 42L46 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </Col>
                </Row>
            </div>
            }
        </Row>
    )
}

export default RoofObstacles;